import React, { useCallback, useContext, useEffect, useState } from "react";

import { campaignService } from "@/features/campaigns/shared/services/campaignService";
import { GlobalContext } from "@/helpers/contexts/contexts";
import SubscriptionBudgetAllocationCheck from "@/shared/components/subscription-budget-check/SubscriptionBudgetAllocationCheck";

function BudgetAllocationIsInProgress({ campaignId }) {
  const { loggedInUser } = useContext(GlobalContext);

  const [isInProgress, setIsInProgress] = useState(false);

  const findNow = useCallback(async () => {
    const reqData = {
      email_id: loggedInUser?.email,
      fk_campaign_id: campaignId,
    };

    const res =
      await campaignService.getIsThereBudgetAllocationInProcessForCamp(reqData);
    if (res.status === 200) {
      setIsInProgress(!res.data);
    }
  }, [campaignId, loggedInUser?.email]);

  useEffect(() => {
    findNow();
  }, [findNow, campaignId]);

  if (isInProgress) {
    return (
      <>
        <SubscriptionBudgetAllocationCheck
          showProgress={false}
          progress={0}
          showBtn
          btnText="Back to Campaigns"
          btnUrl="/launch-campaign"
        />
      </>
    );
  }
  return null;
}

export default BudgetAllocationIsInProgress;
